import { useQuery } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';
import {
  EarningsInsightPreviewResponse,
  earningsInsights,
} from '@toggle/toggle';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

const QUERY_KEY_EARNINGS_INSIGHT_PREVIEW = 'QUERY_KEY_EARNINGS_INSIGHT_PREVIEW';

export const useGetEarningsInsightPreview = (earningsInsightId: string) =>
  useQuery({
    queryKey: [QUERY_KEY_EARNINGS_INSIGHT_PREVIEW, earningsInsightId],
    queryFn: ({ signal }) => {
      const { path, schema } = earningsInsights.getEarningsInsightPreview;
      return wretchRequest<EarningsInsightPreviewResponse>(
        path(earningsInsightId),
        {
          method: 'get',
          schema,
          signal,
        }
      );
    },
    staleTime: getTimeTillEndOfDayMs(),
    enabled: !!earningsInsightId,
  });
